module.exports = __webpack_public_path__ + "images/bbc5d01e15c15a72143cab9c654abdf4.jpg";